import { render, staticRenderFns } from "./newReportChart.vue?vue&type=template&id=dec34aa0&scoped=true&"
import script from "./newReportChart.vue?vue&type=script&lang=js&"
export * from "./newReportChart.vue?vue&type=script&lang=js&"
import style0 from "./newReportChart.vue?vue&type=style&index=0&id=dec34aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec34aa0",
  null
  
)

export default component.exports